<template>
  <el-dialog
    :title="`Выбор экспортера для перевозки №${bid.id}`"
    :visible="visible"
    width="40%"
    custom-class="choose-exporter-modal"
    @close="beforeClose"
  >
    <el-table :data="list" :row-class-name="tableRowClassName">
      <el-table-column label="Наименование" prop="short_name" />
      <el-table-column align="right">
        <template slot-scope="scope">
          <el-button
            v-if="bid.exporter_id !== scope.row.id"
            :loading="loading"
            size="small"
            @click="handleSelect(scope.row.id)"
          >
            Выбрать
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters, mapMutations } from 'vuex'

const Bids = RepositoryFactory.get('bids')

export default {
  name: 'ChooseExporter',
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters({ list: 'organizations/getExporters' }),
  },
  methods: {
    ...mapMutations('bids', ['updateBidData']),
    tableRowClassName({ row }) {
      return row.id === this.bid.exporter_id ? 'selected-row' : ''
    },
    handleSelect(exporter_id) {
      this.loading = true
      const data = { exporter_id }
      const id = this.bid.id

      Bids.patchBids(id, data)
        .then(res => {
          if (res.status === 200) {
            this.beforeClose()
            this.$message.success('Заявка обновлена успешно')
            this.updateBidData({ id, data })
          }
        })
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    beforeClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="sass">
.choose-exporter-modal
  .el-dialog__header
    padding: 20px 40px
    color: #000
  .el-dialog__body
    padding: 0 40px 40px
    color: #000
  .selected-row
    color: #409EFF
</style>
